import React from 'react'
import styled, { css, withTheme } from 'styled-components'
import is from 'styled-is'

import Action from './Action'
import Icon from './Icon'

export const ModuleList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: auto;
`

const shared = css`
  display: inline-flex;
  width: 148px;
  height: 44px;
  border: 1px solid ${(props) => props.theme.colors.text};
  border-radius: 22px;

  justify-content: center;
  align-items: center;

  padding: 0 15px;

  position: relative;
`

export const Module = styled.li`
  ${shared};

  margin: 0.5rem;
`

export const GridModule = styled.div`
  ${shared};

  border-color: currentColor;
  color: ${(props) => props.theme.colors.gray};

  ${is('active')`
    color: ${(props) => props.theme.colors.text};
  `};

  cursor: pointer;

  ${is('row')`
    grid-row: ${(props) => props.row};
  `};
`

const Absolute = styled.span`
  position: absolute;

  ${is('top')`
    top: ${(props) => props.top};
  `};
  ${is('right')`
    right: ${(props) => props.right};
  `};
  ${is('bottom')`
    bottom: ${(props) => props.bottom};
  `};
  ${is('left')`
    left: ${(props) => props.left};
  `};
`

const Circle = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  margin: 0 0.33em;
  vertical-align: middle;
  text-align: center;

  background-color: ${(props) => props.theme.colors.background};
  border-width: 1px;
  border-color: ${(props) => props.border};
  border-style: solid;
  border-radius: 50%;
`

export const ActionModule = withTheme(
  ({
    onLeftClick,
    toLeft,
    onRightClick,
    toRight,
    rightIcon = 'edit',
    leftIcon = 'add',
    children,
    theme,
    ModuleTag = Module,
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
    ...props
  }) => (
    <ModuleTag
      {...props}
      title={typeof children === 'string' ? children : undefined}
    >
      {(onLeftClick != null || toLeft != null) && (
        <Absolute left="-10px">
          <Action onClick={onLeftClick} to={toLeft}>
            <Icon
              small
              text
              name={leftIcon}
              background={theme.colors.background}
            />
          </Action>
        </Absolute>
      )}
      {children}
      {(onRightClick != null || toRight != null) && (
        <Absolute right="-10px">
          <Action onClick={onRightClick} to={toRight}>
            <Icon
              small
              text
              name={rightIcon}
              background={theme.colors.background}
            />
          </Action>
        </Absolute>
      )}
      {topLeft != null && (
        <Absolute left="25%" top="-10px">
          <Circle border={theme.colors.brandPrimary}>{topLeft}</Circle>
        </Absolute>
      )}
      {topRight != null && (
        <Absolute right="25%" top="-10px">
          <Circle border={theme.colors.brandSecondary}>{topRight}</Circle>
        </Absolute>
      )}
      {bottomLeft != null && (
        <Absolute left="25%" bottom="-10px">
          <Circle border={theme.colors.brandPrimary}>{bottomLeft}</Circle>
        </Absolute>
      )}
      {bottomRight != null && (
        <Absolute right="25%" bottom="-10px">
          <Circle border={theme.colors.brandSecondary}>{bottomRight}</Circle>
        </Absolute>
      )}
    </ModuleTag>
  )
)

export default Module
